import { render, staticRenderFns } from "./HomeScreenFour.vue?vue&type=template&id=1b21a8f6&scoped=true&"
import script from "./HomeScreenFour.vue?vue&type=script&lang=js&"
export * from "./HomeScreenFour.vue?vue&type=script&lang=js&"
import style0 from "./HomeScreenFour.vue?vue&type=style&index=0&id=1b21a8f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b21a8f6",
  null
  
)

export default component.exports